import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

const DropdownWithSelectAll = ({ menu, showSelectAll, onSelectAll, label }) => {
  return (
    <>
      {showSelectAll && (
        <Link
          to="#"
          className="h55 d-block font-weight-semibold font-size-14 mb-0"
          style={{padding: "8px 12px"}}
          onClick={onSelectAll}
        >
          {label}
        </Link>
      )}
      {menu}
    </>
  )
}

DropdownWithSelectAll.propTypes = {
  menu: PropTypes.any,
  showSelectAll: PropTypes.bool,
  onSelectAll: PropTypes.func,
  label: PropTypes.string,
}

export default DropdownWithSelectAll
